import { gql } from "../__generated__/gql";

export const GET_CLIENT_AND_INVITATION_WORKERS = gql(`
    query getClientWorkers {
        getClientWorkers {
            ...WorkerInfoWithMissionsFields
        }
        allInvitations {
            count
            elements {
                ...InvitationFields
            }
        }
    }
`);

export const GET_IJM_CHOICES = gql(`
    query getIjmChoices {
        getIjmChoices {
            id
            name
            description
            waitingPeriodDays
            benefitPeriodDays
            clientRate
            workerRate
        }
    }
`);

gql(`
    fragment ClientUserFields on ClientUser {
        id
        firstName
        lastName
        phoneNumber
        email
        avatarUrl
        joinedAt
    }
`);

export const GET_CLIENT_USERS = gql(`
    query getClientUsers($clientId: ID!) {
        getClientUsers(clientId: $clientId) {
            ...ClientUserFields
        }
    }
`);
